let count = 1;
export const getFlowId = () => {
	const suffix = `${count++}`.padStart(4, '0');
	const sliceStart = suffix.length - 4;
	return `${Date.now()}${suffix.slice(sliceStart)}`;
};
